export default __webpack_public_path__ + "0cc958e5c1dc42333c6b29c13578d06f.png";